import { render, staticRenderFns } from "./P01.vue?vue&type=template&id=7515d577&lang=pug"
import script from "./P01.vue?vue&type=script&lang=js"
export * from "./P01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports